module.exports = __webpack_public_path__ + "static/media/scroll-left-blank2.1d350f68.png";